import { getEnvVar } from '../../utils/env';
import { PlayerProfileResponse, isPlayerProfileResponse } from './types';

const PLAYER_PROFILE_API_URL = `https://${getEnvVar('NEXT_PUBLIC_TENANT')}.player-profile-api.${getEnvVar('NEXT_PUBLIC_ENVIRONMENT')}.vmnd.tv/profiles`;

export const fetchPlayerProfiles = async (): Promise<PlayerProfileResponse> => {
  const response = await fetch(PLAYER_PROFILE_API_URL);
  if (!response.ok) {
    throw new Error('Failed to fetch player profiles');
  }
  const data = (await response.json()) as unknown;
  if (!isPlayerProfileResponse(data)) {
    throw new Error('Invalid player profile response');
  }
  return data;
};
